<template>
  <div>
    <label class="grey--text text--darken-4 text-body-2 font-weight-medium">
      {{ title }}
    </label>

    <VueEditor
      v-on="$listeners"
      v-bind="$attrs"
      resize
      :editorOptions="editorOptions"
      class="text-body-2 font-weight-regular mt-1 textarea-editor"
      :class="{ resize: !noResize }"
    />
  </div>
</template>

<script>
import Quill from "quill";

const Embed = Quill.import("blots/embed");

class LineBreak extends Embed {
  static blotName = "linebreak";
  static tagName = "br";
}

Quill.register(LineBreak);

export default {
  props: {
    title: String,
    noResize: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    editorOptions: {
      modules: {
        keyboard: {
          bindings: {
            shiftEnter: {
              key: 13,
              shiftKey: true,
              handler: function (range) {
                this.quill.insertEmbed(range.index, "linebreak", true, "user");
                this.quill.insertText(range.index + 1, "\u200B", "user");
                this.quill.setSelection(range.index + 2, 0);
              },
            },
          },
        },
      },
    },
  }),
};
</script>

<style lang="scss" scoped>
.textarea-editor::v-deep {
  .ql-toolbar {
    border-radius: 8px 8px 0 0;
  }

  .ql-container {
    border-radius: 0 0 8px 8px;
  }

  .ql-editor {
    min-height: auto;
    height: 140px;
  }

  &.resize {
    .ql-editor {
      min-height: 140px;
      height: 140px;
      max-height: calc(100dvh - 340px);
      resize: vertical;
    }
  }
}
</style>
